import { useContext, SetStateAction, Dispatch } from "react";

import { PreventNavigationContext } from "lib/context/NavigationContext";

const usePreventNavigation = (): [
  boolean,
  Dispatch<SetStateAction<boolean>>
] => {
  const { preventNavigation, setPreventNavigation } = useContext(
    PreventNavigationContext
  );

  return [preventNavigation, setPreventNavigation];
};

export default usePreventNavigation;
